(function () {
  let hubSpotFormsPromise = null;

  const loadHubSpotForms = function () {
    if (window.hbspt?.forms) return Promise.resolve();
    if (hubSpotFormsPromise) return hubSpotFormsPromise;

    hubSpotFormsPromise = new Promise(function (resolve, reject) {
      let loader = document.getElementById('hubspot-forms-loader');

      const handleLoad = function () {
        if (window.hbspt?.forms) {
          resolve();
        } else {
          reject(new Error('HubSpot Forms loaded without exposing the forms API.'));
        }
      };

      const handleError = function () {
        loader?.remove();
        reject(new Error('HubSpot Forms failed to load.'));
      };

      if (!loader) {
        loader = document.createElement('script');
        loader.id = 'hubspot-forms-loader';
        loader.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
        loader.async = true;
      }

      loader.addEventListener('load', handleLoad, { once: true });
      loader.addEventListener('error', handleError, { once: true });

      if (!loader.isConnected) {
        document.body.appendChild(loader);
      }
    }).catch(function (error) {
      hubSpotFormsPromise = null;
      throw error;
    });

    return hubSpotFormsPromise;
  };

  const createHubSpotForm = function (container) {
    if (!container || container.hasAttribute('data-hubspot-initialized') || !window.hbspt?.forms) return false;
    container.setAttribute('data-hubspot-initialized', 'true');

    try {
      window.hbspt.forms.create({
        portalId: container.dataset.portalId,
        formId: container.dataset.formId,
        region: container.dataset.region,
        target: '#' + container.id
      });
    } catch (error) {
      container.removeAttribute('data-hubspot-initialized');
      throw error;
    }

    return true;
  };

  const initializeContainers = function (containers) {
    if (!containers.length) return;
    loadHubSpotForms().then(function () {
      containers.forEach(function (container) {
        createHubSpotForm(container);
      });
    }).catch(function () {
      // Leave forms uninitialized so a later interaction can retry the loader.
    });
  };

  const initializeHubSpotForms = function () {
    const immediateContainers = document.querySelectorAll(
      '[data-hubspot-form]:not([data-hubspot-lazy]):not([data-hubspot-proximity])'
    );
    initializeContainers(immediateContainers);

    const proximityContainers = document.querySelectorAll(
      '[data-hubspot-form][data-hubspot-proximity]:not([data-hubspot-lazy])'
    );
    if (!proximityContainers.length) return;

    if (!('IntersectionObserver' in window)) {
      initializeContainers(proximityContainers);
      return;
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        initializeContainers([entry.target]);
      });
    }, { rootMargin: '600px 0px' });

    proximityContainers.forEach(function (container) {
      observer.observe(container);
    });
  };

  window.initializeQuoteHubSpotForm = function () {
    const container = document.querySelector('[data-hubspot-form][data-hubspot-lazy]');
    if (!container || container.hasAttribute('data-hubspot-initialized')) return;
    if (createHubSpotForm(container)) return;

    loadHubSpotForms().then(function () {
      createHubSpotForm(container);
    }).catch(function () {
      // Keep the quote form retryable if the third-party request fails.
    });
  };

  initializeHubSpotForms();
})();
